module.exports = __webpack_public_path__ + "static/media/SOLDEMEXICO_11feb.b5228747.jpg";